import React from 'react';
import { useSelector } from 'react-redux';
import { SkeletonBody } from '@xingternal/skeleton';
import { ErrorGlobal } from '@xingternal/content-error';
import { RootState } from '../../redux';

import styles from './styles.css';
import './print.css?global';
import { PageContentWithHeader } from './PageContent/PageContentWithHeader';
import { PageDetails } from '../../models/page';

export interface TPageContentContainerProps {
  slug: string;
  showHeader?: boolean;
  showLiveDate?: boolean;
  renderMetaComponent: (pageDetails: PageDetails) => React.ReactElement;
}

export const PageContentContainer = ({
  slug,
  showHeader = true,
  showLiveDate = true,
  renderMetaComponent,
}: TPageContentContainerProps): React.ReactElement => {
  const { notFound, loading, error, entity: pageDetails } = useSelector<
    RootState,
    RootState['publicPageDetails']
  >(state => state.publicPageDetails);

  return (
    <>
      {loading && (
        <SkeletonBody className={styles.skeleton} secondary amountRows={100} />
      )}
      {notFound && !loading && <ErrorGlobal type="404" />}
      {error && !notFound && !loading && <ErrorGlobal type="503" />}

      {!loading && pageDetails && (
        <PageContentWithHeader
          showHeader={showHeader}
          showLiveDate={showLiveDate}
          pageDetails={pageDetails}
          slug={slug}
          renderMetaComponent={renderMetaComponent}
        />
      )}
    </>
  );
};
